module.exports = __webpack_public_path__ + "static/media/errorWorkspace.fb6dc849.svg";